import axiosInstance from '../../config/AxiosConfig'
import {BACKEND_ENDPOINT} from '../../Constants'

const EXAMINATION_PATH = 'examination'

//#region Page
export function getPageExaminations(
    userId,
    pageNumber,
    pageRows,
    sortField,
    sortOrder,
    filterRequest,
) {
    return axiosInstance
        .post(
            `${BACKEND_ENDPOINT}/${EXAMINATION_PATH}/getPage`,
            filterRequest,
            {
                params: {
                    userId,
                    pageNumber,
                    pageRows,
                    sortField,
                    sortOrder,
                },
            },
        )
        .then(res => (res.data ? res.data : null))
        .catch(error => console.log(error))
}
//#endregion

//#region Create Or Update
export function createOrUpdateExamination(userId, data) {
    return axiosInstance
        .post(`${BACKEND_ENDPOINT}/${EXAMINATION_PATH}/createOrUpdate`, data, {
            params: {
                userId,
            },
        })
        .then(res => (res.data ? res.data : null))
        .catch(error => console.log(error))
}
//#endregion

//#region Delete
export function deleteExamination(userId, id) {
    return axiosInstance
        .delete(`${BACKEND_ENDPOINT}/${EXAMINATION_PATH}/deleteById`, {
            params: {userId, id},
        })
        .then(res => (res.data ? res.data : null))
        .catch(error => console.log(error))
}
//#endregion
